export default __webpack_public_path__ + "static/media/step-two.61b46e42.png";